module.exports = __webpack_public_path__ + "static/media/faq-expand.22d307f4.svg";